import { Event, Vector2 } from 'three';

export const computePointerPosition = (containerParent: HTMLElement, e: Event) => {
    const pointer = new Vector2();
    const viewportOffset = containerParent.getBoundingClientRect();
    const top = viewportOffset.top;
    const left = viewportOffset.left;
    pointer.x =
        ((e.clientX - left) / containerParent.offsetWidth) *
        2 -
        1;
    pointer.y =
        -((e.clientY - top) / containerParent.offsetHeight) *
        2 +
        1;
    return pointer;
};
